var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarPossibilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.907 22.2306C20.3886 24.9221 17.8471 26.6719 15.2301 26.1387C13.4051 25.7669 12.0255 24.383 11.5334 22.6666",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.408C17.6127 20.0706 18.3365 20.6303 19.1421 21.0582C20.2736 21.6592 21.5666 22 22.9397 22C27.3912 22 31 18.4182 31 14C31 9.58179 27.3912 6 22.9397 6C21.7045 6 20.5341 6.27578 19.4878 6.76868C19.3343 6.84099 19.1835 6.91797 19.0355 6.99943",
    stroke: "currentColor",
    strokeWidth: 1.70845
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.8085,
    r: 9.14578,
    stroke: "currentColor",
    strokeWidth: 1.70845
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarPossibilities);
export default __webpack_public_path__ + "static/media/tabbar-possibilities.b3d4da0e.svg";
export { ForwardRef as ReactComponent };